"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useCurrentWidth = require("./useCurrentWidth");
Object.keys(_useCurrentWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCurrentWidth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCurrentWidth[key];
    }
  });
});